module.exports = __webpack_public_path__ + "img/stones-1@2x.4659415.webp";